import { useQuery } from '@tanstack/react-query';

import { listQueryOptions } from '@/lib/query-client';
import { makeQueryKeys } from '@/lib/query-keys';

import { sessionsService } from '../services';
import type { SessionListParams } from '../types';

export const sessionsKeys = makeQueryKeys('sessions');

interface UseSessionsOptions {
  /** When false, the query stays paused — useful when the caller is building
   *  params from form state and doesn't want to fire with placeholder values. */
  enabled?: boolean;
}

export function useSessions(params: SessionListParams = {}, options: UseSessionsOptions = {}) {
  const { enabled = true } = options;
  return useQuery({
    queryKey: sessionsKeys.list(params),
    queryFn: () => sessionsService.list(params),
    enabled,
    ...listQueryOptions,
  });
}
